import React, { Component } from "react"
import ModalView from "containers/ModalView"
import { Input } from "elements"

const links = [
  {
    route: "#",
    name: "Sign Up",
  },
  {
    route: "/login",
    name: "Login",
  },
]

class ForgotPassword extends Component {
  render() {
    return (
      <ModalView
        title="Forgot Your Password?"
        buttonText="Send Me Reset Password Instructions"
        links={links}
      >
        <Input placeholder="Email address" />
      </ModalView>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/index.js